import React, { useState } from 'react'
import './ConfirmModal.scss'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import PropTypes from 'prop-types'

const RecallSubmissionBulk = ({ visible, onClose, onBulkRecall }) => {
  const [isClicked, setIsClicked] = useState(false)
  return (
    <CModal
      className="confirm-modal"
      visible={visible}
      onClose={onClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Are you sure?</CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>Encounter will be recalled</div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          onClick={() => {
            if (!isClicked) {
              setIsClicked(true)
              onBulkRecall()
            }
          }}
        >
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

RecallSubmissionBulk.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onBulkRecall: PropTypes.func,
}

export default RecallSubmissionBulk
